/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseModuleLecturerResponseData } from './genericApiResponseModuleLecturerResponseData';
import type { GenericApiResponseModuleLecturerResponseMessage } from './genericApiResponseModuleLecturerResponseMessage';
import type { GenericApiResponseModuleLecturerResponsePagination } from './genericApiResponseModuleLecturerResponsePagination';
import type { GenericApiResponseModuleLecturerResponseError } from './genericApiResponseModuleLecturerResponseError';

export interface GenericApiResponseModuleLecturerResponse {
  data?: GenericApiResponseModuleLecturerResponseData;
  message?: GenericApiResponseModuleLecturerResponseMessage;
  pagination?: GenericApiResponseModuleLecturerResponsePagination;
  error?: GenericApiResponseModuleLecturerResponseError;
  statusCode?: number;
}
